import { Component, signal } from '@angular/core';

@Component({
    selector: 'message-divider',
    templateUrl: './message-divider.component.html',
    standalone: false
})
export class MessageDividerComponent {
    public text = signal<string>(null);
}
